import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { pageContext } from 'ctm-util-functions';
import GstMessage from './gst_message';

const AvailableResults = styled.span`
  font-size: 2.4rem;
  margin: ${(props) => (props.isXs ? '1.4rem 0' : '1rem 0 1.9rem')};
`;

const AvailableResultsMessage = (props) => {
    const { resultsLength, hasSavedResults, propertyType, suburb, showFeaturesDisclaimer } = props;
    const isXs = pageContext.getProps().pageState.breakpoint === 'xs';

    return (
        <>
            <AvailableResults isXs={isXs}>
                {(hasSavedResults ? (
                    <>
                        Here are the&nbsp;
                        <strong>
                            {`${resultsLength} saved quotes`}
                        </strong>
                    </>
                ) : (
                    <>
                        We found&nbsp;
                        <strong>
                            {`${resultsLength} results`}
                        </strong>
                    </>
                ))}
                &nbsp;
                {`for your ${propertyType} in ${suburb}`}
                <GstMessage showFeaturesDisclaimer={showFeaturesDisclaimer} />
            </AvailableResults>
        </>
    );
};

AvailableResultsMessage.propTypes = {
    hasSavedResults: PropTypes.bool,
    resultsLength: PropTypes.number,
    propertyType: PropTypes.string,
    suburb: PropTypes.string,
    showFeaturesDisclaimer: PropTypes.bool
};

export default AvailableResultsMessage;
